import React from 'react';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Profile from './components/Profile';
import AuthPage from './components/AuthPage';
import SignupPage from './components/SignUpPage';
import Menu from './components/menu';
import UsersPage from './components/usersPage';
import InviteUsers from './components/inviteUsers';
import { auth } from './firebase';

const Routes = () => {
    const [isAuthenticated, setIsAuthenticated] = React.useState<boolean | null>(null);
    const [drawerOpen, setDrawerOpen] = React.useState<boolean>(true);

    React.useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setIsAuthenticated(!!user);
        });

        return () => unsubscribe();
    }, []);

    const toggleDrawer = () => setDrawerOpen((prev) => !prev);

    if (isAuthenticated === null) {
        return <div>Loading...</div>;
    }

    return (
        <RouterRoutes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<AuthPage />} />
            <Route path="/signup" element={<SignupPage />} />

            <Route
                path="/"
                element={<Menu open={drawerOpen} toggleDrawer={toggleDrawer} />}
            >
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/users" element={<UsersPage />} />
                <Route path="/users/invite" element={<InviteUsers />} />
            </Route>
        </RouterRoutes>
    );
};

export default Routes;
